module.exports = __webpack_public_path__ + "img/eye-contour-serum.79d6fcb6.jpg";